import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
// import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import ErrorModalStyle from "../../styles/errorModalStyle";


class ErrorModal extends React.Component {
    render() {
        let { classes, modalOpen, closeModal } = this.props;
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                onClose={closeModal}
                open={Boolean(modalOpen)}
                style={{zIndex: 130}}
                closeAfterTransition
                // BackdropComponent={() => <Backdrop onClick={closeModal} style={{ visibility: "visible" }} />}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={Boolean(modalOpen)}>
                    <div data-app="error-modal-app-component-wrapper" className={classes.modalWrapper}>
                        <div className={classes.modalHeader}>Error</div>
                        <div className={classes.modalBody}>
                            <div className={`${classes.contentWrapper}`}>
                                {modalOpen}
                            </div>
                            <div className="flex align-items-center justify-content-center m-b-2">
                                <Button
                                    onClick={closeModal}
                                    variant="contained"
                                    color="primary"
                                    className={classes.buttonStyle}
                                    id="ok-button-error-modal"
                                >
                                    OK
                                </Button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        )
    }
}


export default withStyles(ErrorModalStyle)(ErrorModal);

